import type { Sizes } from "@aviary/components/Columns/grid";
import { AUTHOR_TYPES, type AuthorTypes } from "@shared/types/AuthorTypes";

import { useBreakpoints } from "../useBreakpoints/useBreakpoints";

export const useCatalogDrawerColumnWidth = (
  isSearchFilterOpen?: boolean,
  authorType?: AuthorTypes,
  isWiderColumnWidth?: boolean
) => {
  const { phone, tablet, desktop, widescreen, width } = useBreakpoints();
  const isSmallPhone = phone.lessThan;
  const isMobile = tablet.lessThan;
  const shouldRenderThreeCards = desktop.greaterThan && width <= 1334;

  if (isSmallPhone) return 12;
  if (isMobile) return authorType === AUTHOR_TYPES.myUploads ? 12 : 6;

  if (isSearchFilterOpen) {
    if (desktop.greaterThan) {
      return (shouldRenderThreeCards ? 6 : 4) as Sizes;
    }

    if (tablet.greaterThan) {
      return 6 as Sizes;
    }

    return 6 as Sizes;
  }

  if (isWiderColumnWidth && shouldRenderThreeCards) {
    return 4;
  }

  if (widescreen.greaterThan) {
    return 3 as Sizes;
  }

  if (tablet.greaterThan) {
    return 4 as Sizes;
  }

  return 6 as Sizes;
};
